var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.5765832,13.057398 L25.5765832,22.9490773 C25.5765832,24.485033 24.321026,25.7301711 22.7946164,25.7301711 L3.03987191,25.7301711 C1.50343407,25.7301711 0.257905113,24.4746139 0.257905113,22.9482043 L0.257905113,3.19345982 C0.257905113,1.65702198 1.50296648,0.411493023 3.04352452,0.411493023 L12.533682,0.384467996",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 25.3186781,
    height: 25.3457031,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-10",
    stroke: "#005A50",
    mask: "url(#mask-2)",
    strokeWidth: 8,
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1484027,14.2684052 L20.9820531,5.27502054",
    id: "Line",
    stroke: "#005A50",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "#005A50",
    points: "16.2331067 0.411493023 25.5765832 10.204908 25.5765832 0.411493023"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomExport);
export default __webpack_public_path__ + "static/media/custom-export.adb9a196c68d9c0dbc259dfad75ed0f4.svg";
export { ForwardRef as ReactComponent };